import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DistributorUserDrawer from "../components/DistributorUserComponent/DistributorUserDrawer";
import { Grid, Card } from "@mui/material";

import SearchSharpIcon from "@mui/icons-material/SearchSharp";

import { Box } from "@mui/system";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import {
  boxStyle,
  searchStyle,
  form_add,
  buttonStyle,
  headerStyle,
} from "../style/style";
import { distributorUserContext } from "../context/contexts";
import OrgList from "../components/DistributorComponent/OrgList";
import OrgDetail from "../components/DistributorComponent/OrgDetail";
import Profile from "../components/DistributorUserComponent/Profile";
import { Link } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { postobj } from "../apicall/apicall";
import { Button, TextField } from "@mui/material";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { validated } from "../apicall/validateform";

export default function DistributorUser() {
  const [distributor, setdistributor] = useState();

  const [refresh, setrefresh] = useState(false);
  const [id, setid] = useState("");
  const [password, setpassword] = useState({
    old_password: "",
    new_password: "",
  });
  const [pwd2, setpwd2] = useState();
  const [open, setopen] = useState();
  const [detail, setdetail] = useState(false);
  const [page, setpage] = useState({
    Organizations: true,
    Settings: false,
  });
  const [search, setsearch] = useState(
    page.Organizations && detail && sessionStorage.getItem("search_devices")
      ? sessionStorage.getItem("search_devices")
      : "",
  );

  const [clicked, setclicked] = useState(
    page.Organizations && detail && sessionStorage.getItem("search_devices")
      ? true
      : false,
  );
  const history = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    sessionStorage.setItem("search_devices", search);

    setclicked(true);
    setrefresh(!refresh);
  };

  const handlepassword = (e) => {
    const { name, value } = e.target;
    setpassword({
      ...password,
      [name]: value,
    });
  };
  const handlePasswordChange = () => {
    if (validated(password)) {
      if (password.new_password !== password.old_password) {
        if (pwd2 === password.new_password) {
          const url = process.env.REACT_APP_ZEWA_URL + "user/reset-password/";
          const res = postobj(url, password);
          res.then(function (r) {
            if (r["Message"] === "Password changed successfully") {
              NotificationManager.success("Password Changed.", "Success", 2000);
              NotificationManager.remove(NotificationManager.listNotify[0]);

              sessionStorage.setItem("token", "");
              history({ pathname: "/" });
              window.location.reload(true);
            } else {
              NotificationManager.remove(NotificationManager.listNotify[0]);

              NotificationManager.error("Incorrect password", "Failed", 2000);
              reset();
              setopen(false);
            }
          });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Password did not match", "Failed", 2000);
          reset();
          setopen(false);
        }
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "New password can not be same as old password",
        );
      }
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error(
        "Please fill the form correctly",
        "Failed",
        2000,
      );
    }
  };
  const reset = () => {
    setpassword({
      old_password: "",
      new_password: "",
    });
    setpwd2("");
    setopen(false);
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("token") === "" ||
      !sessionStorage.getItem("token")
    ) {
      alert("Please log in to view this page!");
      history({ pathname: "/" });
    }
  }, [history]);
  return (
    <div>
      {localStorage.getItem("role", "DISTRIBUTOR-USER") ? (
        <>
          <distributorUserContext.Provider
            value={{
              page: page,
              setpage: setpage,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <DistributorUserDrawer
                  setsearch={setsearch}
                  setdistributor={setdistributor}
                  refresh={refresh}
                  setrefresh={setrefresh}
                />
              </Grid>
              <Grid item xs={10}>
                <Card sx={boxStyle}>
                  <Card sx={headerStyle}>
                    {page.Organizations
                      ? detail
                        ? id.company_name
                        : "Organizations"
                      : "Setting"}
                    <form style={searchStyle} onSubmit={handleSubmit}>
                      <FormControl variant="standard" sx={searchStyle}>
                        <InputLabel htmlFor="input-with-icon-adornment">
                          Search ...
                        </InputLabel>
                        <Input
                          id="input-with-icon-adornment"
                          startAdornment={
                            <InputAdornment position="start">
                              <SearchSharpIcon color="primary" />
                            </InputAdornment>
                          }
                          value={search}
                          onChange={(e) => {
                            setsearch(e.target.value);
                            if (e.target.value === "") {
                              setrefresh(!refresh);
                              sessionStorage.removeItem("search_devices");

                              setclicked(false);
                            }
                          }}
                        />
                      </FormControl>
                    </form>
                  </Card>
                </Card>
                {page.Organizations && (
                  <Card sx={boxStyle}>
                    {!detail ? (
                      <OrgList
                        id={sessionStorage.getItem("customer_id")}
                        setdetail={setdetail}
                        search={{
                          search: search,
                          setsearch: setsearch,
                        }}
                        refresh={refresh}
                        org_id={{ id: id, setid: setid }}
                        setrefresh={setrefresh}
                      />
                    ) : (
                      <OrgDetail
                        setdetail={setdetail}
                        id={id.customer_id["id"]}
                        search={search}
                        setsearch={setsearch}
                        clicked={clicked}
                        setclicked={setclicked}
                      />
                    )}
                  </Card>
                )}
                {page.Settings && (
                  <Card sx={boxStyle}>
                    <Profile id={sessionStorage.getItem("user_id")} />
                    <Link
                      href="#"
                      variant="body2"
                      sx={{ padding: "0.625rem" }}
                      onClick={() => {
                        setopen(true);
                      }}
                    >
                      Change password
                    </Link>
                  </Card>
                )}
              </Grid>
            </Grid>
          </distributorUserContext.Provider>
          <Dialog
            open={open}
            onClose={() => {
              setopen(false);
            }}
          >
            <DialogTitle>Change Password</DialogTitle>
            <DialogContent>
              <FormControl fullWidth>
                <TextField
                  name="old_password"
                  sx={form_add}
                  type="password"
                  label="Enter Old Password"
                  variant="standard"
                  value={password.old_password}
                  onChange={handlepassword}
                />
                <TextField
                  name="new_password"
                  sx={form_add}
                  type="password"
                  label="Enter New Password"
                  variant="standard"
                  value={password.new_password}
                  onChange={handlepassword}
                />
                <TextField
                  name="New Password"
                  sx={form_add}
                  type="password"
                  label="Re-enter New Password"
                  variant="standard"
                  value={pwd2}
                  onChange={(e) => {
                    setpwd2(e.target.value);
                  }}
                />
                <Box m={1} sx={{ marginLeft: "-10px" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    className="form__custom-button"
                    sx={buttonStyle}
                    type="submit"
                    onClick={handlePasswordChange}
                  >
                    Change
                  </Button>
                  <Button
                    color="error"
                    variant="contained"
                    className="form__custom-button"
                    sx={buttonStyle}
                    type="submit"
                    onClick={reset}
                  >
                    Cancel
                  </Button>
                </Box>
              </FormControl>
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
          {!page.Organizations && <NotificationContainer />}{" "}
        </>
      ) : (
        alert("You do not have permission to access this resource.")
      )}
    </div>
  );
}
